export default abstract class AbstractBuild {
  public static shouldReportMissingTranslations(): boolean {
    return false;
  }
}
